import { formatProductSkuLabel } from '@/lib/catalog/skuUtils'

export type Sale =
	| { type: 'percent'; value: number }
	| { type: 'absolute'; value: number }

export class Item {
	public readonly productId?: string
	public readonly productName?: string
	public readonly skuId?: string
	public readonly skuName?: string
	public readonly sale?: Sale
	public readonly description?: string

	constructor(
		public readonly amount: number,
		public readonly unitPrice: number,
		public readonly taxRate?: number,
		productId?: string,
		productName?: string,
		sale?: Sale,
		description?: string,
		skuId?: string,
		skuName?: string,
	) {
		if (productId !== undefined) {
			this.productId = productId
		}
		if (productName !== undefined) {
			this.productName = productName
		}
		if (skuId !== undefined) {
			this.skuId = skuId
		}
		if (skuName !== undefined) {
			this.skuName = skuName
		}
		if (sale !== undefined) {
			this.sale = sale
		}
		if (description !== undefined) {
			this.description = description
		}
	}

	getSaleDiscountAmount(): number {
		if (this.sale == null) return 0
		if (this.sale.type === 'percent') {
			return this.amount * this.unitPrice * (this.sale.value / 100)
		}
		return this.sale.value / 100
	}

	getDisplayLabel(): string | undefined {
		if (!this.productName) {
			return this.description
		}
		return formatProductSkuLabel(this.productName, this.skuName)
	}

	setAmount(amount: number): Item {
		return new Item(
			amount,
			this.unitPrice,
			this.taxRate,
			this.productId,
			this.productName,
			this.sale,
			this.description,
			this.skuId,
			this.skuName,
		)
	}

	setSale(sale: Sale | undefined): Item {
		return new Item(
			this.amount,
			this.unitPrice,
			this.taxRate,
			this.productId,
			this.productName,
			sale,
			this.description,
			this.skuId,
			this.skuName,
		)
	}

	setDescription(description: string | undefined): Item {
		return new Item(
			this.amount,
			this.unitPrice,
			this.taxRate,
			this.productId,
			this.productName,
			this.sale,
			description,
			this.skuId,
			this.skuName,
		)
	}
}
